<template>
  <b-tag :class="`colorExample ${ this.myclasses }`">{{ content }}</b-tag>
</template>

<script>

export default {
  name: 'colorExample',
  data() {
    return {
      myclasses: '',
    };
  },
  props: ['classes', 'content'],
  watch: {
    classes(newC) {
      if (typeof newC === 'string') {
        this.myclasses = newC;
      }
      this.myclasses = Object.keys(newC).join(' ');
    },
  },
  created() {
    if (typeof this.classes === 'string') {
      this.myclasses = this.classes;
    } else {
      this.myclasses = Object.keys(this.classes).join(' ');
    }
  },
  methods: {
    myDayStatusClasses(d) {
      switch (this.getTodayStatus(d)) {
        case 'MAYBE':
          return { highlighted2: true };
        case 'CANGO':
          return { highlighted: true };
        case 'CANT':
          return { cant: true };
        default:
          return {};
      }
    },
  },
};
</script>

<style>
  /*.colorExample {*/
    /*width: 2rem;*/
    /*height: 1em;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/components/colorExample.vue